import styled from "@emotion/styled";
import { LightMode, Text, Variables } from "@repo/skapa";
import { T } from "@repo/translation";
import { padZeros } from "@repo/utils";

import { CalendarColumn, WeekBlock } from "./components";
import {
  WEEK_BLOCK_HEIGHT,
  WEEK_DATE_TITLE_HEIGHT,
  WEEK_END_HOUR,
} from "./constants";

const TitleContainer = styled.div`
  margin-top: -${Variables.space75};
  background-color: ${LightMode.colourStaticWhite};
`;

export const WeekHours = ({
  startHour,
  blockWidth,
  hasAllDay,
  allDayHeight,
}: {
  startHour: number;
  blockWidth: number;
  hasAllDay: boolean;
  allDayHeight: number;
}) => {
  const blocks = [];

  if (hasAllDay) {
    blocks.push(
      <WeekBlock
        key="allday"
        height={allDayHeight}
        width={blockWidth}
        alignItems="flex-start"
        noBorderRight={false}
      >
        <TitleContainer>
          <Text textStyle="Heading.XS">
            <T translationKey="label.all_day" />
          </Text>
        </TitleContainer>
      </WeekBlock>
    );
  }

  for (let h = startHour; h <= WEEK_END_HOUR; h++) {
    blocks.push(
      <WeekBlock
        key={`h-${h}`}
        height={WEEK_BLOCK_HEIGHT}
        width={blockWidth}
        alignItems="flex-start"
        noBorderBottom={h === WEEK_END_HOUR}
      >
        <TitleContainer>
          <Text textStyle="Heading.XS">{`${padZeros(h)}:00`}</Text>
        </TitleContainer>
      </WeekBlock>
    );
  }

  return (
    <CalendarColumn width={blockWidth}>
      <WeekBlock height={WEEK_DATE_TITLE_HEIGHT} width={blockWidth}></WeekBlock>
      {blocks}
    </CalendarColumn>
  );
};
